import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MatDialogClose } from '@angular/material/dialog';
import { ModelForm } from '@shared/models';
import { ZDialogComponent } from '../z-dialog/z-dialog.component';
import { ZButtonComponent } from '../z-button/z-button.component';
import { NgClass } from '@angular/common';
import { FileUploaderComponent } from '../file-uploader/file-uploader.component';
import { TranslatePipe } from '@ngx-translate/core';

interface SendSignedDocForm {
  action: string;
  file: File[]
}

@Component({
    selector: 'app-send-signed-doc-dialog',
    templateUrl: './send-signed-doc-dialog.component.html',
    styleUrl: './send-signed-doc-dialog.component.scss',
    imports: [ZDialogComponent, ZButtonComponent, NgClass, FileUploaderComponent, MatDialogClose, TranslatePipe]
})

export class SendSignedDocDialog  {

  formGroup: FormGroup<ModelForm<SendSignedDocForm>> = new FormGroup({
    action: new FormControl(),
    file: new FormControl()
  })

  selectedAction: string = '';

  constructor( public dialogRef: MatDialogRef<SendSignedDocDialog>,){}

  ngOnInit(): void {
    this.formGroup.controls.action.valueChanges.subscribe(value => {
      this.selectedAction = value;
    })
  }

  send(): void {
    this.dialogRef.close(this.formGroup.getRawValue())
  }
}
